import React, { useState } from "react";
import styled from "styled-components";
import {
  Delete,
  Edit,
  FileCopy,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@material-ui/icons";
import { NumberInput } from "../../components/Input";
import { Button } from "../../components/Button";
import { Category, IProject } from "../../reducers/project";
import {useDispatch, useSelector} from "react-redux";
import changeProjectCount from "../../actions/project/changeProjectCount";
import deleteCart from "../../actions/project/deleteCart";
import { Link } from "react-router-dom";
import AlertDialog from "../Dialog/Dialog";
import content from "../../content";
import { Desktop, useDesktop } from "../../components/Responsive";
import {getGlassCount, getLoading} from "../../reducers/project/selectors";
import {mapCategoryToAttribute} from "../../components/Attributes/AttributesDrawer";
import {mapGlassPrice} from "../../components/Attributes/AttributesExpansion";

const Wrapper = styled.div<{ open: boolean; desktop: boolean }>`
  width: 100%;
  min-height: 68px;
  max-height: ${(props) => (props.open ? "400px" : "68px")};
  height: ${(props) => (props.open ? "auto" : "68px")};
  margin-bottom: 16px;
  border: 1px solid #eae5e5;
  box-sizing: border-box;
  transition: all 0.3s ease-out;
  padding: 24px ${({ desktop }) => (desktop ? "24" : "12")}px 24px
    ${({ desktop }) => (desktop ? "24" : "12")}px;
  display: flex;
  cursor: pointer;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  overflow: hidden;
  user-select: none;
`;

const Label = styled.div<{ desktop: boolean }>`
  font-weight: bold;
  font-size: ${({ desktop }) => (desktop ? "14" : "12")}px;
  color: #080808;
  opacity: 0.8;
  overflow: ${({ desktop }) => (desktop ? "unset" : "hidden")};
  max-height: ${({ desktop }) => (desktop ? "unset" : "20px")};
`;

const PriceLabel = styled.div<{ color?: any; desktop: boolean }>`
  display: flex;
  align-items:  ${({ desktop }) => (desktop ? "center" : "unset")};
  font-weight: bold;
  font-size: 14px;
  overflow: ${({ desktop }) => (desktop ? "unset" : "hidden")};
  max-height: ${({ desktop }) => (desktop ? "unset" : "20px")};
  color: ${({ color }) => (color ? "#080808" : "#C41230")};
  opacity: ${({ color }) => (color ? 0.6 : 1)};
  z-index: 200;
`;

const Grid = styled.div<{ desktop?: boolean }>`
  display: grid;
  grid-template-columns: ${({ desktop }) => (desktop ? "400px" : "30vw")} ${({
                                                                                                                              desktop,
                                                                                                                            }) => (desktop ? "auto" : "100px")};
  font-size: ${({ desktop }) => (desktop ? "14" : "12")}px;
`;

const sortProjectComponents = (project: IProject) => {
  const array:any = []
  const arrayPrice:any = []

  project.components.forEach(s => {
    if(s.price && Number(s.price) > 0){
      array.push(s as any)
    } else {
      arrayPrice.push(s as any)
    }
  })

  return {...project, components: [...array, ...arrayPrice]}

}

function ProjectExpander({ history, project }: IProjectExpander) {
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const dispatch = useDispatch();
  const loading = useSelector(getLoading)

  const projectSorted = sortProjectComponents(project)

  const glassCount = useSelector(getGlassCount)

    const projectCount = projectSorted.count

  const desktop = useDesktop();

  const handleOpenDialog = () => setOpenDialog(true);
  const handleCloseDialog = () => setOpenDialog(false);

  const onCountChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
    if(Number(e.currentTarget.value) > 0 && !loading) {
      dispatch(changeProjectCount(projectSorted.id, Number(e.currentTarget.value)));
    }
  }


  const label = () => {
    let l = projectSorted.components.filter(Boolean).find((c) => c.category === Category.Model)?.name;
    if (!!projectSorted.components.filter(Boolean).find((c) => c.category === Category.Variant)) {
      l =
        l +
        `, ${
          projectSorted.components.filter(Boolean).find((c) => c.category === Category.Variant)?.name
        }`;
    }
    if (!!projectSorted.components.filter(Boolean).find((c) => c.category === Category.Color)) {
      l =
        l +
        `, ${
          projectSorted.components.filter(Boolean).find((c) => c.category === Category.Color)?.name
        }`;
    }
    return l;
  };

  const cartDelete = (id: string) => () => dispatch(deleteCart(id));
  const copyProject = () =>
    navigator.clipboard.writeText(`${window.location.origin}/${project.id}`);


  return (
    <Wrapper desktop={desktop} open={open} onClick={() => setOpen(!open)}>
      <AlertDialog
        open={openDialog}
        handleClose={handleCloseDialog}
        action={cartDelete(projectSorted.id)}
        title={content.getValue("notification_header_cart")}
        label={''}
      />
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            position: "absolute",
            width: "100%",
            margin: desktop ? "-25px" : "-25px 0px 0px -13px",
            background: open ? "#F5F4F4" : "unset",
            borderBottom: "1px solid #EAE5E5",
            boxSizing: "border-box",
            height: "68px",
          }}
        ></div>
        <div
          style={{
            height: "100%",
            justifyContent: "space-between",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Label desktop={desktop}>{label()}</Label>
          {open && (
            <Grid desktop={desktop} style={{ marginTop: "18px" }}>
              {projectSorted.components.map((s) => (
                <>
                  <div
                    style={{
                      padding: desktop ? "15px 0px" : "8px 0px",
                      borderTop: "1px solid #eae5e5",
                      color: "#080808",
                      opacity: 0.6,
                      fontSize: desktop ? "14px" : "12px",
                    }}
                  >
                    <div style={{color: '#C41230'}}>{mapCategoryToAttribute(s?.category)}</div>
                    {s?.name}
                  </div>
                  <div
                    style={{
                      padding: desktop ? "15px 0px" : "8px 0px",
                      borderTop: "1px solid #eae5e5",
                      color: "#080808",
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    {(s.price && Number(s.price) > 0) ? <>{mapGlassPrice(s, glassCount)} {content.getValue("currency")}</>:<></>}
                  </div>
                </>
              ))}
            </Grid>
          )}
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ display: "flex" }}>
            {!history && (open || desktop) ? (
              <NumberInput
                wrapperStyle={{
                  position: "absolute",
                  marginTop: "-12px",
                  transform: desktop ? "translateX(-50%)" : "translateX(-10%)",
                }}
                placeholder={content.getValue("many")}
                value={projectCount}
                onChange={onCountChange}
              />
            ) : desktop || open ? (
              <PriceLabel desktop={true} color={true} style={{ width: "300px", textAlign: desktop? 'right': 'left', justifyContent: !desktop? "unset": 'flex-end' }}>
                {new Date(Number(projectSorted.date) * 1000)
                  .toISOString()
                  .substr(0, 16).replace('T', ' ')}
              </PriceLabel>
            ) : (
              <></>
            )}
            <Desktop>
              <div style={{ width: "50px" }}></div>
            </Desktop>

            {(!open || desktop) && (
              <PriceLabel
                  desktop={desktop}
                style={{
                  width: desktop ? "250px" : "unset",
                  display: "flex",
                  justifyContent: "flex-end",
                  marginRight: desktop ? "30px" : "10px",
                  fontSize: desktop ? "16px" : "14px",
                  textAlign: "right"
                }}
              >
                {projectSorted.components.length === 0
                  ? 0
                  : projectSorted.components.reduce(
                    (a, b) =>
                      (Number(a) + Number(b?.price) * projectSorted.count).toFixed(
                        2
                      ),
                    ""
                  )}{" "}
                {content.getValue("price_surfix")}
              </PriceLabel>
            )}
            {open ? (
              <KeyboardArrowDown
                style={{
                  fontSize: "18px",
                }}
              />
            ) : (
              <KeyboardArrowUp
                style={{
                  fontSize: "18px",
                }}
              />
            )}
          </div>
          {open && (
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                display: "flex",
                marginTop: "30px",
                justifyContent: desktop ? "flex-end" : "unset",
                flexDirection: desktop ? "row" : "column",
              }}
            >
              {!history && (
                <div style={{ display: "flex" }}>
                  <div>
                    <Button
                      reverse={true}
                      onClick={handleOpenDialog}
                      variant={"text"}
                      Icon={
                        <svg
                          width="14"
                          height="17"
                          viewBox="0 0 14 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13 15.4063C13 15.8289 12.842 16.2343 12.5607 16.5332C12.2794 16.8321 11.8978 17 11.5 17H2.5C2.10218 17 1.72064 16.8321 1.43934 16.5332C1.15804 16.2343 1 15.8289 1 15.4063V4.25H13V15.4063ZM4.5 6.90625C4.5 6.76536 4.44732 6.63023 4.35355 6.5306C4.25979 6.43097 4.13261 6.375 4 6.375C3.86739 6.375 3.74021 6.43097 3.64645 6.5306C3.55268 6.63023 3.5 6.76536 3.5 6.90625V14.3438C3.5 14.4846 3.55268 14.6198 3.64645 14.7194C3.74021 14.819 3.86739 14.875 4 14.875C4.13261 14.875 4.25979 14.819 4.35355 14.7194C4.44732 14.6198 4.5 14.4846 4.5 14.3438V6.90625ZM7.5 6.90625C7.5 6.76536 7.44732 6.63023 7.35355 6.5306C7.25979 6.43097 7.13261 6.375 7 6.375C6.86739 6.375 6.74021 6.43097 6.64645 6.5306C6.55268 6.63023 6.5 6.76536 6.5 6.90625V14.3438C6.5 14.4846 6.55268 14.6198 6.64645 14.7194C6.74021 14.819 6.86739 14.875 7 14.875C7.13261 14.875 7.25979 14.819 7.35355 14.7194C7.44732 14.6198 7.5 14.4846 7.5 14.3438V6.90625ZM10.5 6.90625C10.5 6.76536 10.4473 6.63023 10.3536 6.5306C10.2598 6.43097 10.1326 6.375 10 6.375C9.86739 6.375 9.74021 6.43097 9.64645 6.5306C9.55268 6.63023 9.5 6.76536 9.5 6.90625V14.3438C9.5 14.4846 9.55268 14.6198 9.64645 14.7194C9.74021 14.819 9.86739 14.875 10 14.875C10.1326 14.875 10.2598 14.819 10.3536 14.7194C10.4473 14.6198 10.5 14.4846 10.5 14.3438V6.90625ZM0.5 1.06251H4.25L4.54375 0.441607C4.60598 0.308866 4.70183 0.197207 4.82053 0.119191C4.93922 0.0411758 5.07605 -0.000100538 5.21562 5.82141e-06H8.7875C8.92676 -0.000562966 9.06335 0.0405594 9.18162 0.118662C9.2999 0.196764 9.39508 0.308687 9.45625 0.441607L9.75 1.06251H13.5C13.6326 1.06251 13.7598 1.11848 13.8536 1.2181C13.9473 1.31773 14 1.45286 14 1.59376V2.65626C14 2.79715 13.9473 2.93228 13.8536 3.03191C13.7598 3.13153 13.6326 3.1875 13.5 3.1875H0.5C0.367392 3.1875 0.240214 3.13153 0.146446 3.03191C0.0526781 2.93228 0 2.79715 0 2.65626V1.59376C0 1.45286 0.0526781 1.31773 0.146446 1.2181C0.240214 1.11848 0.367392 1.06251 0.5 1.06251Z"
                            fill="#C41230"
                          />
                        </svg>
                      }
                      label={content.getValue("button_delete")}
                    />
                  </div>
                </div>
              )}
              {!history && <div style={{ width: "15px" }}></div>}
              <div style={{ display: "flex" }}>
                <Link to={`/${project.id}`}>
                  <Button
                    reverse={true}
                    variant={"text"}
                    Icon={
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.84573 3.08379L12.1343 6.43105C12.2728 6.57207 12.2728 6.80215 12.1343 6.94316L4.17177 15.0479L0.788435 15.4301C0.336352 15.482 -0.0464609 15.0924 0.00458078 14.6322L0.380101 11.1885L8.3426 3.08379C8.48114 2.94277 8.70718 2.94277 8.84573 3.08379ZM14.752 2.23398L12.9728 0.423047C12.4186 -0.141016 11.5181 -0.141016 10.9603 0.423047L9.66968 1.73672C9.53114 1.87773 9.53114 2.10781 9.66968 2.24883L12.9582 5.59609C13.0968 5.73711 13.3228 5.73711 13.4614 5.59609L14.752 4.28242C15.3061 3.71465 15.3061 2.79805 14.752 2.23398Z"
                          fill="#C41230"
                        />
                      </svg>
                    }
                    label={content.getValue("button_edit")}
                  />
                </Link>
              </div>
              <div style={{ width: "15px" }}></div>
              <div style={{ display: "flex" }}>
                <div>
                  <Button
                    reverse={true}
                    variant={"text"}
                    onClick={copyProject}
                    Icon={
                      <svg
                        width="15"
                        height="17"
                        viewBox="0 0 15 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.7143 14.875V16.2031C10.7143 16.6432 10.3545 17 9.91071 17H0.803571C0.359766 17 0 16.6432 0 16.2031V3.98438C0 3.54427 0.359766 3.1875 0.803571 3.1875H3.21429V13.0156C3.21429 14.0409 4.05539 14.875 5.08929 14.875H10.7143ZM10.7143 3.45312V0H5.08929C4.64548 0 4.28571 0.356768 4.28571 0.796875V13.0156C4.28571 13.4557 4.64548 13.8125 5.08929 13.8125H14.1964C14.6402 13.8125 15 13.4557 15 13.0156V4.25H11.5179C11.0759 4.25 10.7143 3.89141 10.7143 3.45312ZM14.7647 2.42287L12.5568 0.233385C12.4061 0.0839516 12.2017 1.10499e-06 11.9886 0L11.7857 0V3.1875H15V2.98632C15 2.77499 14.9153 2.57231 14.7647 2.42287Z"
                          fill="#C41230"
                        />
                      </svg>
                    }
                    label={content.getValue("button_copy")}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </Wrapper>
  );
}

export interface IProjectExpander {
  history?: boolean;
  project: IProject;
}

export default ProjectExpander
